import { registerAction } from '../../Action'

const UPDATE_PRESENTATION_PROGRESS = 'UPDATE_PRESENTATION_PROGRESS'

const reducer = (state = {}, action) => {
  const presentationProgress = action.payload
  return {
    ...state,
    presentationProgress,
  }
}

const updatePresentationProgress = registerAction(
  UPDATE_PRESENTATION_PROGRESS,
  { reducer }
)

export default updatePresentationProgress
